var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderInPreview',{attrs:{"isPreview":_vm.isPreview,"data":_vm.m_event}}),_c('div',{staticClass:"list-company-overlay"},[_c('ListCompanyPreview')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }